import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function ProductPresentation() {
  return <section className="py-24 px-4 bg-gradient-to-b from-brand-black to-brand-dark" data-id="element-146">
      <div className="container mx-auto max-w-5xl text-center" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-148">
          
          <h2 className="text-6xl md:text-8xl font-heading font-bold text-white mb-6 tracking-tighter" data-id="element-149">
            CÓDIGO <span className="text-brand-red" data-id="element-150">DESEO™</span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed" data-id="element-151">
            El manual táctico diseñado para que cambies cómo te perciben desde
            esta semana.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto mb-16" data-id="element-152">
          {['No es teoría.', 'No es manipulación barata.', 'No es actuar como idiota.'].map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white/5 p-6 rounded border border-white/10" data-id="element-153">
              <p className="font-bold text-white" data-id="element-154">{item}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} data-id="element-155">
          <p className="text-2xl font-bold text-brand-gold mb-8" data-id="element-156">
            Es un sistema práctico que podés aplicar hoy.
          </p>
          <Button data-id="element-157">Empezar Ahora</Button>
        </motion.div>
      </div>
    </section>;
}